


































































































import { Component, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-toggle';

/**
 * Controlled form toggle button
 *
 * @event change `(checked: boolean, event: MouseEvent)`
 */
@Component
export default class SwToggle extends SwExtendedVue {
  @Model('change', { type: Boolean, default: false })
  value: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ type: Boolean, default: true })
  submitable: boolean;

  @Prop({ type: String, default: '' })
  color: string;

  @Prop({ type: String, default: 'right' })
  direction: 'left' | 'right';

  @Prop({ type: String, default: 'regular' })
  size: 'regular' | 'compact';

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  cssPrefix = cssPrefix;

  get isOff(): boolean {
    return (!this.value);
  }

  get submitValue(): string {
    return this.isOff ? '0' : '1';
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {
      backgroundColor: !this.isOff ? (this.color || undefined) : undefined,
    };
    return style;
  }

  // methods
  private handleToggle(event:Event) {
    if (this.disabled) { return; }
    this.$emit('change', !this.value, event);
  }
}
